import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Check } from 'lucide-react';
import { Button } from '../ui/Button';
import { LocationData } from '../../data/locations';
interface LocationCardProps {
  location: LocationData;
}
export function LocationCard({
  location
}: LocationCardProps) {
  return <div className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col h-full" data-id="element-439">
      {/* Image Placeholder */}
      <div className="h-48 bg-slate-200 flex items-center justify-center text-slate-500 text-sm font-medium tracking-wide" data-id="element-440">
        LOCATION IMAGE PLACEHOLDER
      </div>

      <div className="p-6 flex-1 flex flex-col" data-id="element-441">
        <div className="mb-4" data-id="element-442">
          <h3 className="text-xl font-bold text-[#1a2332] mb-1" data-id="element-443">
            {location.name}
          </h3>
          <p className="text-slate-500 text-sm font-medium mb-3" data-id="element-444">
            {location.city}
          </p>

          <div className="flex items-start text-slate-600 text-sm" data-id="element-445">
            <MapPin className="h-4 w-4 mr-2 mt-0.5 flex-shrink-0 text-[#dc2626]" data-id="element-446" />
            <span data-id="element-447">{location.address}</span>
          </div>
        </div>

        <div className="border-t border-slate-100 pt-4 mb-6 flex-1" data-id="element-448">
          <ul className="space-y-2" data-id="element-449">
            {location.highlights.map((highlight, index) => <li key={index} className="flex items-start text-sm text-slate-700" data-id="element-450">
                <Check className="h-4 w-4 mr-2 mt-0.5 text-[#dc2626] flex-shrink-0" data-id="element-451" />
                {highlight}
              </li>)}
          </ul>
        </div>

        <Link to={`/locations/${location.id}`} data-id="element-452">
          <Button variant="outline" className="w-full border-[#1a2332] text-[#1a2332] hover:bg-[#1a2332] hover:text-white" data-id="element-453">
            View Location
          </Button>
        </Link>
      </div>
    </div>;
}